/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { closelightbox } from '../../util/Functions';
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import moment from 'moment';
import 'moment/locale/es';


const SpaceTxCsv = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(false);
  const [start_date, setStartDate] = useState(moment(new Date()).subtract(1, 'month').format().slice(0, 10))
  const [end_date, setEndDate] = useState(moment(new Date()).format().slice(0, 10))
  const [form, setForm] = useState({
    start_date: new Date(start_date).toISOString(),
    end_date: new Date(end_date).toISOString(),
  });
  const [error, setErrors] = useState({
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = () => {
    validateForm(form, error)
  };

  const send = async () => {
    props.changeLoader(true);
    setZPos(-1)
    let data = form;
    data["space_uuid"] = props.content;

    let request = await API.service( "spaceTxCsv", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.data.data.response == "OK" && request.status == 200) {
      if (request.data.data.content) {
        let url = request.data.data.content;
        window.open(url, "_blank");
        closelightbox()
        props.changeLoader(false);
        setZPos(45)
        props.changeAlert(true, "success", "Reporte descargado con éxito.");
        return;
      }
    } else {
      props.changeLoader(false);
      setZPos(45)
      props.changeAlert(true, "error", "Error en descarga de reporte.");
    }
  };

  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    if (!e.target.value) {
      er[field] = "Dato obligatorio";
      f[field] = e.target.value
    } else {
      er[field] = "";
      f[field] = new Date(e.target.value).toISOString()
    }
    
    validateForm(f, er);
    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
  };

  const validateForm = (f, err) => {
    if ( f["start_date"] && f["end_date"] && !err["start_date"] && !err["end_date"] ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    if(f["start_date"] == f["end_date"]){
      setDisabled(true);
    }
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          Descargar Movimientos
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={6}>
              <TextField
                defaultValue={start_date} onChange={changeValue.bind(this, "start_date")}	label="Fecha Inicial"	size="small"	type={"date"}	fullWidth	InputProps={{inputProps: { max: new Date().toJSON().substr(0, 10)} }} error={error.start_date !== ""} helperText={error.start_date ? error.start_date : ''} InputLabelProps={{ shrink: true }}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                defaultValue={end_date} onChange={changeValue.bind(this, "end_date")}	label="Fecha Final"	size="small" type={"date"}	fullWidth	InputProps={{inputProps: { max: new Date().toJSON().substr(0, 10)} }} error={error.end_date !== ""} helperText={error.end_date ? error.end_date : ''} InputLabelProps={{ shrink: true }}/>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Descargar</Button>  
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default SpaceTxCsv;
